// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__hlSIH","buttons":"SendReceipts_buttons__3iT9v","email":"SendReceipts_email__M7oA_","bookApptTitle":"SendReceipts_bookApptTitle__3VZL9"};